import { createRouter, createWebHistory } from 'vue-router'
import LiveView from '../views/LiveView.vue'
import RecView from '../views/RecView.vue'
import CowManageView from '../views/CowManageView.vue'
import BarnManageView from '../views/BarnManageView.vue'
import EventView from '../views/EventView.vue'
import UserManageView from '../views/UserManageView.vue'
import LoginView from '../views/LoginView.vue'
import FoodTimeSettingView from '../views/FoodTimeSettingView.vue'
import BullSettingView from '../views/BullSettingView.vue'
import EggSettingView from '../views/EggSettingView.vue'
import PregnancyPeriodSettingView from '../views/PregnancyPeriodSettingView.vue'
import SystemUpdateView from '../views/SystemUpdateView.vue'
import PasswordChangeSettingView from '../views/PasswordChangeSettingView.vue'
import PrivacyView from '../views/PrivacyView.vue'
import TermsOfServiceView from '../views/TermsOfServiceView.vue'
import PhonePasswordChangeView from '../views/PhonePasswordChangeView.vue'
import PhoneForgotPasswordView from '../views/PhoneForgotPasswordView.vue'
import PhoneReturnApplicationView from '../views/PhoneReturnApplicationView.vue'
import PhoneAppStoreView from '../views/PhoneAppStoreView.vue'
import Eula from '../views/EULA.vue'
import Privacy from '../views/Privacy.vue'
import { CognitoUserAccessor } from "@/views/js/cognito-login"

const requireAuth = (to, from, next) => {
  CognitoUserAccessor.isAuthenticated()
    .then(() => {
      next()
    })
    .catch(() => {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    })
}

const routes = [
  {
    path: '/',
    name: 'liveview',
    component: LiveView,
    beforeEnter: requireAuth,
  },
  {
    path: '/recview',
    name: 'recview',
    component: RecView,
    beforeEnter: requireAuth,
  },
  {
    path: '/cowmanageview',
    name: 'cowmanageview',
    component: CowManageView,
    beforeEnter: requireAuth,
  },
  {
    path: '/barnmanageview',
    name: 'barnmanageview',
    component: BarnManageView,
    beforeEnter: requireAuth,
  },
  {
    path: '/eventview',
    name: 'eventview',
    component: EventView,
    beforeEnter: requireAuth,
  },
  {
    path: '/usermanageview',
    name: 'usermanageview',
    component: UserManageView,
    beforeEnter: requireAuth,
  },
  {
    path: '/foodtimesettingview',
    name: 'foodtimesettingview',
    component: FoodTimeSettingView,
    beforeEnter: requireAuth,
  },
  {
    path: '/bullsettingview',
    name: 'bullsettingview',
    component: BullSettingView,
    beforeEnter: requireAuth,
  },
  {
    path: '/eggsettingview',
    name: 'eggsettingview',
    component: EggSettingView,
    beforeEnter: requireAuth,
  },
  {
    path: '/pregnancyperiodsettingview',
    name: 'pregnancyperiodsettingview',
    component: PregnancyPeriodSettingView,
    beforeEnter: requireAuth,
  },
  {
    path: '/systemupdateview',
    name: 'systemupdateview',
    component: SystemUpdateView,
    beforeEnter: requireAuth,
  },
  {
    path: '/passwordchangesettingview',
    name: 'passwordchangesettingview',
    component: PasswordChangeSettingView,
    beforeEnter: requireAuth,
  },
  {
    path: '/privacyview',
    name: 'privacyview',
    component: PrivacyView,
    beforeEnter: requireAuth,
  },
  {
    path: '/termsofserviceview',
    name: 'termsofserviceview',
    component: TermsOfServiceView,
    beforeEnter: requireAuth,
  },
  {
    path: '/phonepasswordchange',
    name: 'phonepasswordchangeview',
    component: PhonePasswordChangeView,
  },
  {
    path: '/phoneforgotpassword',
    name: 'phoneforgotpasswordview',
    component: PhoneForgotPasswordView,
  },
  {
    path: '/phonereturnapplication',
    name: 'phonereturnapplicationview',
    component: PhoneReturnApplicationView,
  },
  {
    path: '/phoneappstore',
    name: 'phoneappstoreview',
    component: PhoneAppStoreView,
  },
  {
    path: '/eula',
    name: 'eula',
    component: Eula,
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: Privacy,
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
